
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { exportStyledXlsxWorkbook, formatMoneyVN, XlsxColumn, XlsxSheetSpec } from "@/core/helpers/exportXlsx";
import { hideModal } from "@/core/helpers/dom";
import Condition from "yup/lib/Condition";
import { typeOptionsSemester } from "./promotion.vue";

interface ICustomer {
    id: string;
    name: string;
    releasedIn: number;
    rate: string;
    value: number;
    description: string;
    isCondition: string;
    uomid: string;
}
interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface IData {
    id: string;
    name: string;
    type: string;
    releasedIn: number;
    rate: string;
    value: number;
    description: string;
    isCondition: string;
    uomid: string;
    productnumber: string
    code: string
    programtype: string
}
export function reFormatCurrent(value) {
    // FIX edit-after-save: chịu cả NUMBER (sửa lại row vừa lưu -> value là số -> trước đây number.replaceAll ném TypeError, bấm Lưu im lặng) + undefined -> 0 thay vì NaN
    return +String(value ?? '').replaceAll('.', '')
}
export default defineComponent({
    name: "Combination-code",
    components: {
        Datatable,
    },
    data() {
        return {
            //Khối "Tính nhanh từ học phí" — chỉ tham khảo, không tự ghi vào ô Giá trị
            tuitionList: [] as any[],
            calcTuitionId: '',
        }
    },
    methods: {
        //Ngành để chọn làm gốc tính: lọc theo Chương trình đang chọn (Tiếng Việt/Song ngữ), bỏ ngành chưa cài học phí
        tuitionOptions() {
            return (this.tuitionList || []).filter(t =>
                t.wholeCourseFee > 0 && (!this.formData?.programtype || t.programtype == this.formData.programtype))
        },
        calcTuition() {
            return this.tuitionList.find(t => t.id == this.calcTuitionId) || null
        },
        //Gợi ý giá trị = học phí toàn khóa × tỉ lệ (làm tròn đồng); thiếu 1 trong 2 -> null (nút Điền disabled)
        calcSuggestValue() {
            const tuition = this.calcTuition()
            const rate = +this.formData?.rate
            if (!tuition || !rate || isNaN(rate)) { return null }
            return Math.round(tuition.wholeCourseFee * rate)
        },
        applySuggestValue() {
            const suggest = this.calcSuggestValue()
            if (!suggest) { return }
            //Ô Giá trị lưu dạng chuỗi có dấu chấm (submit gọi reFormatCurrent để bỏ chấm)
            this.formData.value = suggest.toLocaleString('vi-VN')
        },
        funcChangeMultiBuy(checked) {
            console.log('checked',checked)
            if(checked) {
                this.addArrItemAddition()
                
            }
            else {
                this.formData.benefitaddition = []
            }
        },
        addArrItemAddition() {
            // console.log('this.formData',this.formData)
            if (this.formData.benefitaddition.length > 0) {
                const item = this.formData.benefitaddition[this.formData.benefitaddition.length - 1]
                if (!item.semester || !item.type || !item.value) return;
            }
            let temp = {
                name: "",
                semester:"", 
                type: "", 
                value: "", 
            }
            this.formData.benefitaddition.push(temp)
        },
        delArrItemAddition(ind){
            const lookArr = this.formData.benefitaddition.filter((e,index)=>index != ind)
            this.formData.benefitaddition = lookArr
        },
        addCondition (index) {
            let temp = {
                date: "",
                value: "",
                description: "",
            }
            this.arrPromotion[index].condition.push(temp)
        },
        removeRowCondition(index,ind) {
            if(this.arrPromotion[index].condition.length >0) {
                this.arrPromotion[index].condition = this.arrPromotion[index].condition.filter((i,ic) =>ic != ind)
            }
        },
        removeRowScholar(index) {
            if(this.arrPromotion.length >1) {
                this.arrPromotion = this.arrPromotion.filter((i,ind) =>ind != index)
            }
        },
        addNewRow() {
            let temp = {
                name: "",
                value: "",
                description: "",
                condition: [],
            }
            this.arrPromotion.push(temp)
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        formatCurrentMoney(evt,value) {
            if (this.isNumber(evt)) {
                let formated = (value||'').toString()
                if (formated != '') {
                    return (+formated.replaceAll('.', ''))?.toLocaleString('vi-VN') ? (+formated.replaceAll('.', ''))?.toLocaleString('vi-VN') : ""
                }
            }
        },
        
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "id": '',
                "name": "",
                "type": "",
                "releasedIn": 0,
                "rate": "",
                "value": 0,
                "description": "",
                "isCondition": "",
                "uomid": "",
                "productnumber": "",
                "code":"",
                "programtype":"TIENG_VIET",
                condition: {
                    value: "",
                    date: "",
                    description: "",
                },
                addition: [],
                benefitaddition: [],
                namemultibuy: "",
                isactive: true,
                leaderonly: false,
                bypasscondition: false,
                adminonly: false,

            }
            this.arrPromotion = [
                {
                    name: "",
                    value: "",
                    description: "",
                    condition: [],
                }
            ]
            this.formData = temp
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa học bổng này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let index = this.tableData.findIndex(item => item.id == record.id)
                    this.tableData.splice(index, 1);
                    axios.delete(`/setting/scholarship/${record.id}`)
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            this.resetDataForm()
            this.idFormEdit = record.id
            await axios.get(`/setting/scholarship/${record.id}`)
                .then(({ data }) => {
                    // console.log('data',data)
                    if(data.condition) {
                        data.isCondition = true
                        data.condition.value = data.condition.value?.toLocaleString('vi-VN')

                    }
                    else {
                        data.condition = {
                            value: "",
                            date: "",
                            description: "",
                            type: "",
                        }
                    }
                    if(data.addition) {
                        data.addition.forEach((item: any) => {
                            item.value = item.value?.toLocaleString('vi-VN')
                            item.condition?.forEach((i: any) => {
                                i.value = i.value?.toLocaleString('vi-VN')
                            })
                        })
                        this.arrPromotion = data.addition
                        data.isAddition = true
                        
                    }
                    data.benefitaddition = data.benefitaddition?.map(i=>{
                        let value = i.value
                        if(i.type == 'amount') {
                            value = value?.toLocaleString('vi-VN')
                        }
                        i.value = value
                        return i
                    })||[]
                    if(data.benefitaddition && data.benefitaddition.length != 0) {
                        data.ismultibuy = true
                        data.namemultibuy = data.benefitaddition[0]?.namepromotion

                    }
                    
                    data.value = data.value?.toLocaleString('vi-VN')
                    this.formData = data
                    this.isEdit = true
                    this.kt_modal_add_combination?.click()
                })
                .catch((errors) => {
                    console.log('err', errors)
                });
        },
        exportFile() {
            // Xuất Excel phía FE có style — sheet 1: danh sách HB (kèm cột tóm tắt ưu đãi cộng thêm),
            // sheet 2: chi tiết "Ưu đãi cộng thêm" (addition[] + điều kiện kích hoạt),
            // sheet 3: ưu đãi gắn từ CT khuyến mãi (benefitaddition[], phân bậc theo số kỳ đóng)
            const columns: XlsxColumn[] = [
                { label: "Tên học bổng", width: 30, wrap: true },
                { label: "Mã", width: 16 },
                { label: "Loại chương trình", width: 16, align: "C" },
                { label: "Số học kỳ cấp", width: 13, align: "C" },
                { label: "Tỷ lệ", width: 10, align: "R" },
                { label: "Giá trị", width: 16, align: "R" },
                { label: "UOM ID", width: 12, align: "C" },
                { label: "Ưu đãi cộng thêm", width: 42, wrap: true },
                { label: "Ưu đãi kèm CT khuyến mãi", width: 42, wrap: true },
                { label: "Trạng thái", width: 12, align: "C" },
                { label: "Phạm vi", width: 30, wrap: true },
                { label: "Mô tả", width: 50, wrap: true },
            ]
            // rate lưu 0.3/0.48/1 -> hiển thị 30%/48%/100% (nhân qua x10000 tránh lệch float kiểu 0.48*100)
            const formatRate = (rate: any) => {
                if (rate === null || rate === undefined || rate === '') return ''
                const num = Number(rate)
                return Number.isNaN(num) ? String(rate) : `${Math.round(num * 10000) / 100}%`
            }
            const formatDate = (v: any) => (v ? new Date(v).toLocaleDateString('en-GB') : '')
            const conditionTypeLabels: Record<string, string> = { 'Deposit': 'Phí giữ suất', 'Tuition Fee': 'Học phí' }
            try {
                const additionRows: any[][] = []
                const additionGroups: number[] = []
                const promoRows: any[][] = []
                const promoGroups: number[] = []

                const rows: any[][] = this.tableData.map((item: any, groupIdx: number) => {
                    const additions = Array.isArray(item.addition) ? item.addition : []
                    const benefitAdditions = Array.isArray(item.benefitaddition) ? item.benefitaddition : []

                    // Sheet 2: mỗi ưu đãi cộng thêm 1 dòng, điều kiện kích hoạt gộp nhiều dòng trong 1 ô
                    additions.forEach((a: any) => {
                        const conds = (Array.isArray(a.condition) ? a.condition : [])
                            .map((c: any) => `• [${conditionTypeLabels[c.type] || c.type || ''}] ${c.description || ''} — hạn ${formatDate(c.date)}`)
                            .join('\n')
                        additionRows.push([
                            item.name || '', item.type || '',
                            a.name || '', `${formatMoneyVN(a.value)} đ`,
                            a.isExtend ? 'Có' : 'Không', conds, a.description || '',
                        ])
                        additionGroups.push(groupIdx)
                    })
                    // Sheet 3: mỗi bậc ưu đãi từ CT khuyến mãi 1 dòng
                    benefitAdditions.forEach((b: any) => {
                        promoRows.push([
                            item.name || '', item.type || '',
                            b.namepromotion || '', b.name || '',
                            b.semester ? `Đóng ${b.semester} học kỳ` : '',
                            `${formatMoneyVN(b.value)} đ`,
                        ])
                        promoGroups.push(groupIdx)
                    })

                    // Sheet 1: cột tóm tắt để nhìn phát biết HB nào có cộng thêm (chi tiết xem sheet 2/3)
                    const additionSummary = additions.map((a: any) => `• ${a.name} (${formatMoneyVN(a.value)} đ)`).join('\n')
                    // Array.from thay vì spread Set — tsconfig target es5 không cho spread iterable
                    const promoSummary = Array.from(new Set(benefitAdditions.map((b: any) => b.namepromotion).filter(Boolean)))
                        .map(name => `• ${name}`).join('\n')
                    return [
                        item.name || '',
                        item.type || '',
                        this.optionsPrograms.find((v) => v.value == item.programtype)?.label || item.programtype || '',
                        item.releasedIn ?? '',
                        formatRate(item.rate),
                        formatMoneyVN(item.value),
                        item.uomid || '',
                        additionSummary,
                        promoSummary,
                        item.isactive === false ? 'Ngưng' : 'Đang dùng',
                        [
                            item.leaderonly ? 'Chỉ trưởng nhóm' : '',
                            item.bypasscondition ? 'Bỏ qua điều kiện' : '',
                            item.adminonly ? 'Chỉ admin chọn' : '',
                        ].filter(Boolean).join(', '),
                        item.description || '',
                    ]
                })

                const sheets: XlsxSheetSpec[] = [{
                    title: 'DANH SÁCH HỌC BỔNG',
                    summary: `Tổng: ${rows.length} học bổng`,
                    sheetName: 'Học bổng',
                    columns,
                    rows,
                }]
                if (additionRows.length) {
                    sheets.push({
                        title: 'ƯU ĐÃI CỘNG THÊM CỦA HỌC BỔNG',
                        summary: `Tổng: ${additionRows.length} ưu đãi cộng thêm`,
                        sheetName: 'Ưu đãi cộng thêm',
                        columns: [
                            { label: "Học bổng", width: 28, wrap: true },
                            { label: "Mã", width: 14 },
                            { label: "Tên ưu đãi", width: 30, wrap: true },
                            { label: "Giá trị", width: 15, align: "R" },
                            { label: "isExtend", width: 10, align: "C" },
                            { label: "Điều kiện kích hoạt", width: 60, wrap: true },
                            { label: "Mô tả", width: 50, wrap: true },
                        ],
                        rows: additionRows,
                        rowGroups: additionGroups,
                    })
                }
                if (promoRows.length) {
                    sheets.push({
                        title: 'ƯU ĐÃI GẮN TỪ CHƯƠNG TRÌNH KHUYẾN MÃI',
                        summary: `Tổng: ${promoRows.length} dòng (theo bậc số kỳ đóng)`,
                        sheetName: 'Ưu đãi kèm CTKM',
                        columns: [
                            { label: "Học bổng", width: 28, wrap: true },
                            { label: "Mã", width: 14 },
                            { label: "Chương trình khuyến mãi", width: 45, wrap: true },
                            { label: "Tên bậc ưu đãi", width: 34, wrap: true },
                            { label: "ĐK: Số kỳ đóng", width: 16, align: "C" },
                            { label: "Giá trị cộng thêm", width: 16, align: "R" },
                        ],
                        rows: promoRows,
                        rowGroups: promoGroups,
                    })
                }
                exportStyledXlsxWorkbook({ fileBaseName: 'danh-sach-hoc-bong', sheets })
            } catch (error) {
                console.log('err', error)
                Swal.fire({
                    text: 'Không thể xuất file Excel.',
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: 'Đóng',
                    customClass: { confirmButton: 'btn btn-primary' },
                })
            }
        },
    },
    async mounted() {
        //Danh sách nạp qua getData() (định nghĩa trong setup) để LƯU XONG nạp lại đúng 1 nguồn,
        //không còn vá tay từng dòng — kiểu vá cũ thiếu field là hàng hiện sai/mất badge.
        await (this as any).getData()
        //Biểu học phí cho khối "Tính nhanh" trong modal (chỉ đọc, không ảnh hưởng dữ liệu học bổng)
        await axios.get(`/setting/tuition`)
            .then(({ data }) => {
                this.tuitionList = (data || []).map(i => ({
                    id: i.id,
                    majorName: i.majorName,
                    majorCode: i.majorCode,
                    programtype: i.programtype,
                    wholeCourseFee: +i.wholeCourseFee || 0,
                }))
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
    },
    setup() {
        const optionsPrograms = ref([
        {
            label: "Tiếng Việt",
            value: 'TIENG_VIET'
        },
        {
            label: "Song ngữ",
            value: 'SONG_NGU'
        },
        ])
        const optionsType = ref([
        {
            label: "Tuition Fee",
            value: 'Tuition Fee'
        },
        {
            label: "Deposit",
            value: 'Deposit'
        },
        ])
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');

        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "Học bổng",
                key: "name",
                sortable: true,
            },
            {
                name: "Chương trình",
                key: "programtype",
                sortable: true,
            },
            {
                name: "Số HK cấp",
                class: 'w-100px text-center',
                key: "releasedIn",
                sortable: true,
            },
            {
                name: "Tỷ lệ",
                class: 'w-90px text-center',
                key: "rate",
                sortable: true,
            },
            {
                name: "Giá trị",
                class: 'text-end',
                key: "value",
                sortable: true,
            },
            {
                name: "Kèm theo",
                key: "extras",
                sortable: false,
            },
            {
                name: "Phạm vi",
                key: "scope",
                sortable: false,
            },
            {
                name: "Mô tả",
                key: "description",
                sortable: true,
            },
            {
                name: "HÀNH ĐỘNG",
                key: "actions",
                sortable: false,
                class: "text-center"
            },
        ]);
        const formData = ref<any>({})
        const tableData = ref<Array<ICustomer>>([]);
        //NGUỒN DUY NHẤT dựng bảng: mounted và sau khi Lưu đều gọi hàm này (trước đây mounted nạp
        //riêng còn submit vá tay 1 dòng -> thiếu field là hàng vừa lưu hiện sai / mất badge).
        async function getData() {
            await axios.get(`/setting/scholarship`)
                .then(({ data }) => {
                    tableData.value = (data || []).map((item: any) => ({
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        releasedIn: parseInt(item.releasedIn),
                        rate: item.rate,
                        value: parseInt(item.value),
                        description: item.description,
                        condition: item.condition,
                        uomid: item.uomid,
                        code: item.code,
                        programtype: item.programtype,
                        addition: item.addition, // "Ưu đãi cộng thêm" (kèm điều kiện kích hoạt) — cần cho export
                        benefitaddition: item.benefitaddition, // ưu đãi gắn từ CT khuyến mãi (ngày hội HB)
                        isactive: item.isactive, // badge "Ngưng" khi tắt
                        leaderonly: item.leaderonly, // cột Phạm vi
                        bypasscondition: item.bypasscondition, // cột Phạm vi
                        adminonly: item.adminonly, // cột Phạm vi
                    })) as any
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        }
        const arrMajors = ref([]) as any;
        const formRef = ref<HTMLFormElement | null>(null);
        const arrPromotion = ref<any>([
            {
                name: "",
                value: "",
                description: "",
                condition: [],
            }
        ])
        const checkNumber = (rule: any, value: any, callback: any) => {
            if (!value) {
                return callback(new Error('Vui lòng điền trường này'))
            }
            setTimeout(() => {
                if (!Number.isInteger(value)) {
                    callback(new Error('Vui lòng nhập các chữ số'))
                } else {
                    callback()
                }
            }, 1000)
        }
        const rules = ref({
            name: {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change"
            },
            releasedIn: [{ validator: checkNumber, trigger: 'blur' }],
            value: {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change"
            },
        })
        const submit = () => {
            if (!formRef.value) { return; }
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let condition = null as any
                    let addition = null as any
                    if(formData.value.isCondition) {
                        condition = formData.value.condition
                        condition.value = reFormatCurrent(condition.value)
                    }
                    if(formData.value.isAddition) {
                        addition = JSON.parse(JSON.stringify(arrPromotion.value))
                        addition.forEach((item: any) => {
                            item.value = reFormatCurrent(item.value)
                            item.condition?.forEach((i: any) => {
                                i.value = reFormatCurrent(i.value)
                            })
                        })
                        
                    }
                    // console.log('addition',addition)

                    let data = {
                        "name": formData.value.name != "" ? formData.value.name : undefined,
                        "type": formData.value.name != "" ? formData.value.type : undefined,
                        "releasedIn": formData.value.releasedIn != 0 ? formData.value.releasedIn : undefined,
                        "rate": formData.value.rate != "" ? +formData.value.rate : undefined,
                        "value": formData.value.value ? reFormatCurrent(formData.value.value) : undefined,
                        "description": formData.value.name != "" ? formData.value.description : undefined,
                        "addition": addition,
                        "condition": condition,
                        "uomid": formData.value.uomid != "" ? formData.value.uomid : undefined,
                        "productnumber": formData.value.productnumber != "" ? formData.value.productnumber : undefined,
                        "code": formData.value.code != "" ? formData.value.code : undefined,
                        "programtype": formData.value.programtype != "" ? formData.value.programtype : undefined,
                        "benefitaddition": formData.value.benefitaddition?formData.value.benefitaddition.map(i=>{
                            let value = i.value
                            if(i.type == 'amount') {
                                value = reFormatCurrent(value)
                            }
                            i.value = value
                            i.namepromotion = formData.value.namemultibuy
                            return i
                        }):[],
                        //3 cờ phạm vi hiển thị. "leaderonly" trước giờ có ô tick nhưng KHÔNG nằm trong payload
                        //-> tick xong lưu vẫn mất; gửi kèm luôn cho đúng với ô đang hiện trên form.
                        //Học bổng mới mặc định BẬT (isactive undefined ở form cũ -> vẫn phải lưu true)
                        "isactive": formData.value.isactive !== false,
                        "leaderonly": !!formData.value.leaderonly,
                        "bypasscondition": !!formData.value.bypasscondition,
                        "adminonly": !!formData.value.adminonly,
                    }
                    await axios[method](`/setting/scholarship${id}`, data)
                        .then(async () => {
                            //Nạp lại từ server thay vì vá dòng bằng tay: bản vá cũ thiếu benefitaddition
                            //+ 4 cờ (isactive/leaderonly/bypasscondition/adminonly) nên hàng vừa lưu hiện sai.
                            await getData()
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        return {
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            getData,
            Permission,
            arrMajors,
            submit,
            formData,
            isEdit,
            idFormEdit,
            optionsPrograms,
            optionsType,
            arrPromotion,
            typeOptionsSemester,
        };
    },
});
